import React from 'react';
import classes from './Faq.module.scss';
import clsx from 'clsx';
import Image from 'components/atoms/Image/Image';
import SplitRow from 'components/organisms/SplitRow/SplitRow';
import FullWidthCta from 'components/organisms/FullWidthCta/FullWidthCta';
import FaqAccordion from '../../molecules/FaqAccordion/FaqAccordion';
import Button from '../../atoms/Button/Button';
import faqQuestions from './faqQuestions';
import { PRIVACY_PROMISE } from '../pages';
import Txt from '../../atoms/Txt/Txt';
import PageContentWrapper from 'components/templates/Page/PageContentWrapper';
import { useRouter } from 'next/router';
import useScrollToElement from 'hooks/useScrollToElement';
import faqImg1 from './assets/faq_img_1.png';

const Faq: React.FC = () => {
  const router = useRouter();
  const scrollToElement = useScrollToElement();
  const hashMatch = router.asPath.match(/#.*/gi);
  const hash = hashMatch ? hashMatch[0] || '' : '';

  React.useEffect(() => {
    window.location.hash = hash?.replace('#', '');
    if (hash?.match(/#.+/)) {
      scrollToElement(hash);
    }
  }, [hash, scrollToElement]);

  const onFaqNavClick = (key: string) => {
    scrollToElement(key);
  };

  return (
    <main className={clsx('fadedPageBg', classes.root)}>
      <SplitRow
        mobileColumnOrderSwapped
        contentAlignedTop
        isFirstRow
        leftColumn={
          <>
            <Txt component="h1">FAQ&apos;s</Txt>
            <nav className={classes.buttonsContainer}>
              {faqQuestions.map(({ key, heading }) => (
                <Button
                  key={key}
                  className={clsx(classes.filterButton)}
                  onClick={() => onFaqNavClick(key)}
                >
                  <Txt>{heading}</Txt>
                </Button>
              ))}
            </nav>
          </>
        }
        rightColumn={<Image src={faqImg1} alt="FAQ's" />}
      ></SplitRow>

      <PageContentWrapper>
        <div className={classes.faqQuestionsWrapper}>
          {faqQuestions.map(({ key, heading, questions }) => (
            <FaqAccordion key={key} id={key} heading={heading} questions={questions} />
          ))}
        </div>

        <FullWidthCta
          title={<Txt>The Qmee Privacy Promise</Txt>}
          ctaText="Tell me more"
          ctaLink={PRIVACY_PROMISE.path}
        >
          At Qmee, we understand the growing concerns around privacy, so check out our promise of
          putting you first.
        </FullWidthCta>
      </PageContentWrapper>
    </main>
  );
};
export default Faq;
